var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CCF040",
    d: "M11.554 27.381c.773 0 1.4-.638 1.4-1.426v-6.957c0-.787-.627-1.425-1.4-1.425-.773 0-1.4.638-1.4 1.425v6.957c0 .788.627 1.426 1.4 1.426M15.572 9.808c.773 0 1.4-.638 1.4-1.425V1.426c0-.788-.627-1.426-1.4-1.426-.773 0-1.4.638-1.4 1.426v6.957c0 .787.627 1.425 1.4 1.425M7.537 9.808c.773 0 1.4-.638 1.4-1.425V1.426C8.937.638 8.31 0 7.537 0c-.773 0-1.4.638-1.4 1.426v6.957c0 .787.627 1.425 1.4 1.425",
    transform: "translate(.932 .199)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91D9BF",
    d: "M21.708 6.001H1.4c-.773 0-1.4.638-1.4 1.426C0 8.213.627 8.85 1.4 8.85h1.272v4.501h.01c.12 4.888 4.041 8.815 8.872 8.815 4.831 0 8.753-3.927 8.871-8.815h.011V8.851h1.272c.773 0 1.4-.638 1.4-1.424 0-.788-.627-1.426-1.4-1.426",
    transform: "translate(.932 .199)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.eb0b0b19c88a90a065f50c4d28ed6b63.svg";
export { ForwardRef as ReactComponent };